/**
 * Drops text in at a textarea's cursor rather than at the end, replacing any
 * selection, then puts the cursor after what was inserted. Shared by the
 * variable chips and the Insert condition helper.
 */
export function insertAtCursor(
  field: HTMLTextAreaElement | null,
  value: string,
  text: string,
  onChange: (value: string) => void,
) {
  if (!field) {
    onChange(value + text)
    return
  }

  const start = field.selectionStart ?? value.length
  const end = field.selectionEnd ?? start
  onChange(value.slice(0, start) + text + value.slice(end))

  requestAnimationFrame(() => {
    field.focus()
    field.setSelectionRange(start + text.length, start + text.length)
  })
}
